import * as React from "react";
import type { SVGProps } from "react";
const SvgXCircle = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M17.004 6.332A7.566 7.566 0 0 0 5.95 16.553a1 1 0 0 1-1.597 1.204 9.566 9.566 0 1 1 2.862 2.53 1 1 0 0 1 .999-1.732 7.566 7.566 0 0 0 8.79-12.223M10.577 12l-2.72-2.72 1.415-1.413 2.72 2.719 2.719-2.72 1.414 1.415-2.72 2.72 2.72 2.718-1.414 1.415-2.72-2.72-2.719 2.72-1.414-1.415z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgXCircle;
